// Generated by CoffeeScript 2.7.0
// ==============================================================================
// MODULES - COMPONENTS - QUESTION CARD LIST
// ==============================================================================
import $ from "jquery";

$(function() {
  // Add question cards calling GET API
  return $('.C--questionCardList_viewmore > div').on('click', function() {
    var $dummy, $this, $wrapper, addCards, success;
    // --------------------------------------------------------------------------
    // Define Methods
    // --------------------------------------------------------------------------
    // Set a disabled style
    addCards = function($wrapper, $dummyCard, cards) {
      var $newCard, card, i, len, results;
      results = [];
      for (i = 0, len = cards.length; i < len; i++) {
        card = cards[i];
        $newCard = null;
        // Create new card
        // Clone
        // Wrapper
        results.push($.when($newCard = $dummyCard.clone(), $newCard.removeAttr('id').removeClass('is_dummy').attr({
          'data-href': card.link_path,
          'data-subject': card.subject
        // Ribbon
        // Caption
        // Head
        // DOM
        }), $newCard.find('.C--ribbon').attr('data-subject', card.subject), $newCard.find('.C--ribbon_text').html(card.ribbon_text), card.ribbon_text === 'チャレンジ' ? $newCard.find('.C--ribbon_text').addClass('type_small') : void 0, card.caption ? $newCard.find('.C--questionCard_caption').html(card.caption) : $newCard.find('.C--questionCard_caption').remove(), $newCard.find('.C--questionCard_bighead a').attr('href', card.link_path).html(card.head_text), $newCard.append(card.dom)).done(function() {
          // Append the card to wrapper
          salvattore['append_elements']($wrapper.get(0), [$newCard.get(0)]);
          return window.searchDummyLinks();
        }));
      }
      return results;
    };
    // Success to GET
    success = function($button, data) {
      if (data['finish_to_display?']) {
        // Set a button status
        $button.addClass('do_hide');
      }
      // Add contents
      return $.when(addCards($wrapper, $dummy, data.cards)).done($button.removeClass('is_disabled'), $button.attr('data-offset', ~~$button.attr('data-offset') + 1));
    };
    // --------------------------------------------------------------------------
    // Main Process
    // --------------------------------------------------------------------------
    // Set variables
    $this = $(this);
    $wrapper = $this.parent().parent().find('.C--questionCardList_wrapper');
    $dummy = $('#JS--questionCard_dummy');
    // Append a disabled style
    if ($this.hasClass('is_disabled')) {
      return;
    }
    $this.addClass('is_disabled');
    // DELETE ME!!!!
    // --------------
    // @data
    // {
    //   "cards": [
    //     {
    //       "head_text"  : "見出しテキスト：必須",
    //       "ribbon_text": "リボンのテキスト（例題など）：必須",
    //       "caption"    : "キャプション（中1英語など）：任意（おそらく不要）",
    //       "link_path"  : "リンク先URL：必須",
    //       "subject"    : "教科名（english/mathematics/science/social）：必須",
    //       "dom"        : "<div>...</div>"：必須
    //     },
    //     ...
    //   ],
    //   "finish_to_display?": true / false（最後までカードを表示しきったか）
    // }

    // Call GET API
    return $.ajax({
      type: 'GET',
      url: `${document.URL}ajax_index`,
      data: {
        get_num: 6,
        offset: ~~$this.attr('data-offset')
      },
      success: function(data, status, xhr) {
        return success($this, data);
      }
    });
  });
});
